
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12.429 20.373"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(.5 .5)","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('rect',{attrs:{"width":"2.857","height":"2.857","transform":"translate(4.286 16.516)"}}),_c('path',{attrs:{"d":"M11.428 5.714a4.554 4.554 0 01-1.335 3.214l-1.284 1.316a4.865 4.865 0 00-1.673 4.041H4.285v-.714A5.714 5.714 0 015.958 9.53l1.773-1.8a2.784 2.784 0 00.84-2.011 2.857 2.857 0 00-5.714 0H0a5.715 5.715 0 0111.429 0z"}})])])
          )
        }
      }
    